import { render, staticRenderFns } from "./ui-main.vue?vue&type=template&id=8937d2b8"
import script from "./ui-main.vue?vue&type=script&lang=js"
export * from "./ui-main.vue?vue&type=script&lang=js"
import style0 from "./ui-main.vue?vue&type=style&index=0&id=8937d2b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports